import { render, staticRenderFns } from "./AuthReplay.vue?vue&type=template&id=5c48f28f&scoped=true"
import script from "./AuthReplay.vue?vue&type=script&lang=js"
export * from "./AuthReplay.vue?vue&type=script&lang=js"
import style0 from "./AuthReplay.vue?vue&type=style&index=0&id=5c48f28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48f28f",
  null
  
)

export default component.exports